/**
 * The hub's ONE 3D model — where its routes live, with no dependencies.
 *
 * Pure on purpose: the scan-attach service and the composables that speak these
 * routes are imported by plain Node tests, and `services/api.ts` reaches the
 * pinia stores (and `import.meta.env`), so a constant that lived beside the
 * fetch helpers would drag that graph into every test. `services/bimModelApi.ts`
 * re-exports these, so a Vue surface still has one import.
 */

/** The hub model's own route. */
export const BIM_MODELS_PATH = '/bim-models';

/** The stable file path (`/api/bim-models/<id>/file`) every transport can route. */
export function bimModelFilePath(modelId: string): string {
  return `${BIM_MODELS_PATH}/${modelId}/file`;
}

/** The rooms sidecar's own route. */
export function bimModelRoomsPath(modelId: string): string {
  return `${BIM_MODELS_PATH}/${modelId}/rooms`;
}
